import moment from 'moment';

export const maxDate = moment().add(2, 'years').toDate();
export const minDate = moment().subtract(20, 'years').toDate();

